export function formatDateTime(date, locale) {
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'Europe/Amsterdam'
  }).format(date)
}
